import React from 'react';
import { getDisplayValue, getTemplateFieldDisplayMappings, isNonEmptyValue } from './helper';
import { JsonMessage, JsonMessageTypeEnum } from './Message';
import { BridgeApiTemplate, BridgeApiTemplateField } from '../api-internal';
import './StructuredMessage.scss';

const StructuredMessage = ({
  jsonMessage,
  template,
  customFields = [],
}: {
  jsonMessage: JsonMessage;
  template?: BridgeApiTemplate;
  customFields?: BridgeApiTemplateField[];
}): React.JSX.Element => {
  let templateMapping: Record<string, BridgeApiTemplateField>;

  if (template) {
    switch (jsonMessage.type) {
      case JsonMessageTypeEnum.STRUCTURED_REQUEST:
        templateMapping = getTemplateFieldDisplayMappings(template.providedFields);
        break;
      case JsonMessageTypeEnum.STRUCTURED_REQUEST_RESPONSE:
        templateMapping = getTemplateFieldDisplayMappings(template.requestedFields.concat(customFields));
        break;
      case JsonMessageTypeEnum.CONCLUSION_SENDER:
        templateMapping = getTemplateFieldDisplayMappings(template.senderConclusionFields);
        break;
      case JsonMessageTypeEnum.CONCLUSION_RECIPIENT:
        templateMapping = getTemplateFieldDisplayMappings(template.recipientConclusionFields);
        break;
    }
  }

  const nonEmptyAttributes = Object.entries(jsonMessage.attributes).filter(([, value]) => isNonEmptyValue(value));

  return (
    <div className='structured-message-content'>
      {jsonMessage.message && <div className='text-s'>{jsonMessage.message}</div>}
      {nonEmptyAttributes.length > 0 && (
        <div className='attributes'>
          {nonEmptyAttributes.map(([attribute, value], key) => (
            <div className='attribute' key={key}>
              <div className='attribute-key text-s'>
                {templateMapping && templateMapping[attribute] ? templateMapping[attribute].displayName : attribute}
              </div>
              <div className='attribute-value text-strong-s'>
                {getDisplayValue(value, templateMapping ? templateMapping[attribute] : undefined)}
              </div>
            </div>
          ))}
        </div>
      )}
      {jsonMessage.responseComment && <div className='request-comment text-s'>{jsonMessage.responseComment}</div>}
    </div>
  );
};

export default StructuredMessage;
